"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCaptionTweens = getCaptionTweens;
exports.addVideoClipTweens = addVideoClipTweens;
exports.addPhotoClipTweens = addPhotoClipTweens;

function getCaptionTweens(guid, animation, TweenMax, ease) {
  const {
    inDuration,
    intermissionDuration,
    outDuration
  } = animation;
  const timing = {
    t: 0
  };
  const tweens = [];
  const startTween = TweenMax.to(timing, inDuration / 1000, {
    t: inDuration,
    roundProps: 't',
    startAt: {
      t: 0
    },
    ease,
    onUpdateParams: ['{self}', guid],
    onUpdate: tmObj => {
      animation.goToAndStop(tmObj.target.t);
    }
  });
  tweens.push(startTween);

  if (outDuration > 0) {
    const endTween = TweenMax.to(timing, outDuration / 1000, {
      t: inDuration + intermissionDuration + outDuration,
      roundProps: 't',
      startAt: {
        t: inDuration + intermissionDuration
      },
      onUpdateParams: ['{self}', guid],
      onUpdate: tmObj => {
        animation.goToAndStop(tmObj.target.t);
      }
    });
    tweens.push(endTween);
  }

  return tweens;
} // create a tweens for video clips and add to timeline


function addVideoClipTweens(promoVideo, timeline, draw, drawFilter, clearContext, context, context2, TweenMax, ease, onSeekEvent) {
  const tweenOnComplete = promovideo => {
    promoVideo.activeVideo.onseeked = null;
    promovideo.pause();
  };

  const tweenPrarams = [promoVideo, '{self}'];
  const {
    inTransition,
    idle,
    outTransition
  } = promoVideo;

  if (inTransition.transition === 'fade') {
    const inTween = TweenMax.to(promoVideo, inTransition.duration, {
      startAt: {
        t: inTransition.offset,
        a: 0
      },
      t: `+=${inTransition.duration}`,
      a: 1,
      ease,
      onUpdateParams: tweenPrarams,
      onCompleteParams: tweenPrarams,
      onUpdate: (promovideo, self) => {
        context2.globalAlpha = self.target.a;

        if (self.ratio === 0) {
          clearContext(context2);
          promoVideo.activeVideo.onseeked = null;
        } else if (timeline.paused()) {
          onSeekEvent('SEEK_STARTED', promoVideo.guid, self.target.t);
          promovideo.currentTime = self.target.t;

          promoVideo.activeVideo.onseeked = () => {
            console.log('in paused seeked', self.target.t, promoVideo.guid);
            promoVideo.activeVideo.onseeked = null;

            if (self.ratio !== 0) {
              clearContext(context2);
              draw(promovideo.drawObj, context2);
              drawFilter(promovideo.filter, context2);
            }

            onSeekEvent('SEEK_COMPLETED', promoVideo.guid, promoVideo.currentTime);
          };
        } else {
          if (promovideo.paused) {
            console.log('in - play', self.target.t, promoVideo.guid);
            promovideo.currentTime = self.target.t;
            promovideo.play();
          }

          clearContext(context2);
          draw(promovideo.drawObj, context2);
          drawFilter(promovideo.filter, context2);
        }
      },
      onComplete: promovideo => {
        clearContext(context2);
        promovideo.pause();
      }
    });
    promoVideo.tweens.push(inTween);
    timeline.add(inTween, inTransition.start);
  }

  const IdleTween = TweenMax.to(promoVideo, idle.duration, {
    startAt: {
      t: idle.offset,
      a: 1
    },
    t: `+=${idle.duration}`,
    ease,
    onUpdateParams: tweenPrarams,
    onCompleteParams: [...tweenPrarams, 'idle'],
    onUpdate: (promovideo, self) => {
      context.globalAlpha = 1;

      if (self.ratio === 0) {
        clearContext(context);
        promoVideo.activeVideo.onseeked = null;
      } else if (timeline.paused()) {
        onSeekEvent('SEEK_STARTED', promoVideo.guid, self.target.t);
        promovideo.currentTime = self.target.t;

        promoVideo.activeVideo.onseeked = () => {
          console.log('idle paused seeked', self.target.t, promoVideo.guid);
          promoVideo.activeVideo.onseeked = null;

          if (self.ratio !== 0) {
            draw(promovideo.drawObj, context);
            drawFilter(promovideo.filter, context);
          }

          onSeekEvent('SEEK_COMPLETED', promoVideo.guid, promoVideo.currentTime);
        };
      } else {
        if (promovideo.paused) {
          console.log('idle - play', self.target.t, promoVideo.guid);
          promovideo.currentTime = self.target.t;
          promovideo.play();
        }

        draw(promovideo.drawObj, context);
        drawFilter(promovideo.filter, context);
      }
    },
    onComplete: tweenOnComplete
  });
  promoVideo.tweens.push(IdleTween);
  timeline.add(IdleTween, idle.start);

  if (outTransition.transition === 'fade') {
    const outTween = TweenMax.to(promoVideo, outTransition.duration, {
      startAt: {
        t: outTransition.offset,
        a: 1
      },
      t: `+=${outTransition.duration}`,
      a: 0,
      ease,
      onUpdateParams: tweenPrarams,
      onCompleteParams: tweenPrarams,
      onUpdate: (promovideo, self) => {
        context.globalAlpha = self.target.a;

        if (self.ratio === 0) {
          clearContext(context);
          promoVideo.activeVideo.onseeked = null;
        } else if (timeline.paused()) {
          onSeekEvent('SEEK_STARTED', promoVideo.guid, self.target.t);
          promovideo.currentTime = self.target.t;

          promoVideo.activeVideo.onseeked = () => {
            console.log('out paused seeked', self.target.t, promoVideo.guid);
            promoVideo.activeVideo.onseeked = null;

            if (self.ratio !== 0) {
              clearContext(context);
              draw(promovideo.drawObj, context);
              drawFilter(promovideo.filter, context);
            }

            onSeekEvent('SEEK_COMPLETED', promoVideo.guid, promoVideo.currentTime);
          };
        } else {
          if (promovideo.paused) {
            console.log('out - play', self.target.t, promoVideo.guid);
            promovideo.currentTime = self.target.t;
            promovideo.play();
          } // if (self.ratio !== 0) {


          clearContext(context);
          draw(promovideo.drawObj, context);
          drawFilter(promovideo.filter, context); // }
        }
      },
      onComplete: tweenOnComplete
    });
    promoVideo.tweens.push(outTween);
    timeline.add(outTween, outTransition.start);
  }
} // create a tweens for photo clips and add to timeline


function addPhotoClipTweens(promoPhoto, timeline, draw, drawFilter, clearContext, context, context2, TweenMax, ease) {
  const tweenPrarams = [promoPhoto, '{self}'];
  const {
    inTransition,
    idle,
    outTransition
  } = promoPhoto;

  if (inTransition.transition !== 'cut') {
    const inTween = TweenMax.to(promoPhoto, inTransition.duration, {
      startAt: {
        t: inTransition.offset,
        a: 1
      },
      t: `+=${inTransition.duration}`,
      a: 1,
      ease,
      onUpdateParams: tweenPrarams,
      onCompleteParams: tweenPrarams,
      onUpdate: (promovideo, self) => {
        clearContext(context2);
        context2.globalAlpha = self.target.a;
        promovideo.currentTime = self.target.t * 1000;

        if (self.ratio !== 0) {
          draw(promovideo.drawObj, context2);
          drawFilter(promovideo.filter, context2);
        }
      },
      onComplete: () => {
        clearContext(context2);
      }
    });
    promoPhoto.tweens.push(inTween);
    timeline.add(inTween, inTransition.start);
  }

  const IdleTween = TweenMax.to(promoPhoto, idle.duration, {
    startAt: {
      t: idle.offset,
      a: 1
    },
    t: `+=${idle.duration}`,
    ease,
    onUpdateParams: tweenPrarams,
    onUpdate: (promovideo, self) => {
      context.globalAlpha = 1;
      promovideo.currentTime = self.target.t * 1000;

      if (self.ratio === 0) {
        clearContext(context);
      } else {
        draw(promovideo.drawObj, context);
        drawFilter(promovideo.filter, context);
      }
    }
  });
  promoPhoto.tweens.push(IdleTween);
  timeline.add(IdleTween, idle.start);

  if (outTransition.transition === 'fade') {
    const outTween = TweenMax.to(promoPhoto, outTransition.duration, {
      startAt: {
        t: outTransition.offset,
        a: 1
      },
      t: `+=${outTransition.duration}`,
      a: 0,
      ease,
      onUpdateParams: tweenPrarams,
      onUpdate: (promovideo, self) => {
        clearContext(context);
        context.globalAlpha = self.target.a;
        promovideo.currentTime = self.target.t * 1000;
        draw(promovideo.drawObj, context);
        drawFilter(promovideo.filter, context);
      }
    });
    promoPhoto.tweens.push(outTween);
    timeline.add(outTween, outTransition.start);
  }
}